import { contentApi as api } from "../Api";
import setupInterceptors from "../setupInterceptors";

const contentSetupInterceptors = () => {
  return setupInterceptors(api);
};

export default contentSetupInterceptors;
